import React, { useEffect, useState } from 'react'
import { useDispatch } from "react-redux";
import moment from 'moment'
import InfoIcon from '@mui/icons-material/Info';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import { Tooltip, IconButton } from "@mui/material";
import logo from "assets/images/link.png";
import config from "config/config";
import { sendAnalytics } from "utils/sendAnalytics";
import ErpRepository from '../../repository/erpRepository'
import FeaturesPlan from '../../components/featuresPlan/featuresPlan'
import { formatNumberWithDecimals } from '../../helpers/stringHelpers'
import { Popup } from '../../components/Popup/Popup'
import { setPack } from 'store/features/planes/planesSlice';

const Plans = () => {
  const dispatch = useDispatch();
  const [tenant, setTenant] = useState({
    pack: '',
    name_plan: '',
    users_qty: 0,
    finish_date: ''
  })
  const [user, setUser] = useState({
    nombre: '',
    id: '',
    telefono: '',
    current_users_qty: 0
  })
  const [billing, setBilling] = useState({
    plural_name: '',
    exchange_rate: 0,
    max_sales_qty: 0,
    max_sales_amount: 0,
    sales_qty: 0,

  })
  const [discount, setDiscount] = useState({
    total_discounts: 0
  })
  const [status, setStatus] = useState('disabled')
  const [maxSales, setMaxSales] = useState(0)
  const [sales, setSales] = useState(0)
  const [titleSales, setTitleSales] = useState('')
  const [renewSubscription, setRenewSubscription] = useState(false)
  const [testPlanPro, setTestPlanPro] = useState(false)
  const [testPlanStandard, setTestPlanStandard] = useState(false)
  const [open, setOpen] = useState(false)
  const [openAlert, setOpenAlert] = useState(false)
  const [openAlertWarning, setOpenAlertWarning] = useState(false)
  const [questionPlan, setQuestionPlan] = useState('')
  const [textPlan, setTextPlan] = useState('')
  const [titlePlan, setTilePlan] = useState('')
  const [planSelected, setPlanSelected] = useState(config.packBasic)
  const vertical = 'top'
  const horizontal = 'center'

  useEffect(() => {
    ErpRepository({
      dispatch,
      datasourceUrl: 'settings/company/billing_account/',
      method: 'GET',
    }).then(response => {
      const name_plan = identifyPlan(response.tenant?.pack)
      const finish_date = moment(response.tenant?.finish_date).format('DD-MM-YYYY')
      let objTenant = {
        pack: response.tenant?.pack,
        tenant_id: response.tenant?.tenant_id,
        name_plan: name_plan,
        users_qty: response.tenant?.users_qty,
        finish_date: finish_date,
        company_phone: response.company_phone,
      }
      let objUser = {
        nombre: response.user?.nombre,
        id: response.user?.id,
        email: response.user?.email,
        telefono: response.user?.telefono,
        current_users_qty: response?.current_users_qty
      }
      let objBilling = {
        plural_name: response.billing?.plural_name,
        exchange_rate: response.billing?.exchange_rate,
        currency_symbol: response.billing?.currency_symbol,
        max_sales_qty: response.billing?.max_sales_qty,
        sales_qty: response.billing?.sales_qty,
        max_sales_amount: response.billing?.max_sales_amount,
      }
      dispatch(setPack(response.tenant?.pack))
      identifySales(response.billing)
      setTenant(objTenant)
      setUser(objUser)
      setBilling(objBilling)
      validateRenewSubscription(response.tenant?.finish_date, response.tenant?.pack, response.billing)
      validateSubirPlan(response.tenant?.pack)
      totalDiscounts(objUser)
      setTextPlan('Prueba 30 días de nuestros planes Estándar o Pro. Una vez estés decidido del plan que deseas probar, haz click en el plan.')
      setTilePlan('Subir Plan')
    })
    // eslint-disable-next-line
  }, [])

  const identifyPlan = (planType) => {
    let planName = ''
    switch (planType) {
      case config.packBasic:
        planName = 'Plan Basic' // PACK_BASIC (MYPE)
        setStatus('planBlue')
        break
      case config.packStandard:
        planName = 'Plan Estándar' // PACK_STANDARD
        setStatus('planBlue')
        break
      case config.packPro:
        planName = 'Plan Pro' // PACK_PRO
        setStatus('planGreen')
        break
      case config.packFree:
        planName = 'Plan Free' //PACK_FREE (Free)
        setStatus('planFree')
        break
      case config.packEntrepreneur:
        planName = 'Plan Emprendimiento' // PACK_EMPRENDEDOR (Emprendimiento)open
        setStatus('planBlue')
        break
      case config.packUsageBased:
        planName = 'Plan Gratuito'
        setStatus('planFree')
        break
      default:
        planName = 'Plan Free'
        setStatus('planFree')
        break
    }
    return planName
  }
  const identifySales = (billingType) => {
    if (billingType.max_sales_amount > -1) {
      setSales(billingType.current_sales_amount)
      setMaxSales(billingType.max_sales_amount)
      setTitleSales('dólares.')
    } else {
      setSales(billingType.sales_qty)
      setMaxSales(billingType.max_sales_qty)
      setTitleSales('Pedidos.')
    }
  }
  const validateRenewSubscription = (finishDate, planType, billing) => {
    let renewSubscriptionComp = renewSubscription
    const hoy = new Date()
    const fechaA = finishDate
    // const fechaA = '2022-05-04'
    const fechaB = moment(hoy).format('YYYY-MM-DD')
    const fecha1 = moment(fechaA)
    const fecha2 = moment(fechaB)
    let diasDiferencia = fecha1.diff(fecha2, 'days')
    // cuando la cuenta este menor a 30 días antes de llegar a la fecha de vencimiento o haya pasado su vencimiento
    if (diasDiferencia < 30) {
      setRenewSubscription(true)
      renewSubscriptionComp = true
    }

    // Cuando la cuenta esté a 5.000 $us. de llegar a su límite o haya sobrepasado su límite.
    if (renewSubscriptionComp === false) {
      let maxAmount = 0
      let maxSale = 0
      let parmComp = 5000 // $us
      let differenceAmount = 0
      let differenceAmountC = 0
      if (billing.max_sales_amount > -1) {
        //convertir a dolares
        switch (billing.currency_symbol) {
          case 'Bs':
            maxAmount = (billing.max_sales_amount * 6.96)
            maxSale = (billing.current_sales_amount * 6.96)
            break
          case '$':
            maxAmount = (billing.max_sales_amount * 1)
            maxSale = (billing.current_sales_amount * 1)
            break
          case 'S/':
            maxAmount = (billing.max_sales_amount * 3.814)
            maxSale = (billing.current_sales_amount * 3.814)
            break
          case 'MXN':
            maxAmount = (billing.max_sales_amount * 21.4996)
            maxSale = (billing.current_sales_amount * 21.4996)
            break
          default:
            maxAmount = (billing.max_sales_amount * 1)
            maxSale = (billing.current_sales_amount * 1)
            break
        }
        differenceAmount = (maxAmount - parmComp)
        // differenceAmount = (50000 - parmComp)
        differenceAmountC = differenceAmount >= 0 ? differenceAmount : differenceAmount * -1
        if (maxSale > differenceAmountC) {
          setRenewSubscription(true)
          renewSubscriptionComp = true
        }
        if (renewSubscriptionComp === false) {
          if (maxSale > maxAmount) {
            setRenewSubscription(true)
            renewSubscriptionComp = true
          }
        }
      }
    }
    // Cuando la cuenta esté a 30 pedidos de llegar su límite (solo aplicable al Plan Usage Based) o haya sobrepasado su límite.
    // TODO: Cuando la cuenta esté a 30 pedidos de llegar su límite (solo aplicable al Plan Usage Based - Plan Gratuito) o haya sobrepasado su límite.
    if (renewSubscriptionComp === false) {
      // max_sales_qty, sales_qty
      if (planType === config.packUsageBased) {
        let maxSalesQty = billing.max_sales_qty
        let salesQty = billing.sales_qty
        let parmCompQty = 30 // $us
        let differenceQty = 0
        let differenceQtyC = 0
        differenceQty = (maxSalesQty - parmCompQty)
        differenceQtyC = differenceQty >= 0 ? differenceQty : differenceQty * -1
        if (salesQty > differenceQtyC) {
          setRenewSubscription(true)
          renewSubscriptionComp = true
        }
        if (renewSubscriptionComp === false) {
          if (salesQty > maxSalesQty) {
            setRenewSubscription(true)
            renewSubscriptionComp = true
          }
        }
      }
    }
  }
  const validateSubirPlan = async (planType) => {
    const purchaseHystory = await fetchDataSubscription()
    if (planType === config.packUsageBased && purchaseHystory === false) {
      setTestPlanPro(true)
      setTestPlanStandard(true)
    }
  }
  const fetchDataSubscription = async () => {
    try {
      const response = await ErpRepository({
        dispatch,
        datasourceUrl: 'settings/company_setting/',
        method: 'GET',
      })
      const tenantId = response?.results[0]?.tenant_id
      try {
        const response = await ErpRepository({
          dispatch,
          diferentBaseUrl: true,
          datasourceUrl: `users/company/${tenantId}/payment_subscriptions/`,
          method: 'GET',
        })
        response.results.forEach(item =>
          item['nombre_plan'] = item.plan.commercial_title
        )
        if (response?.results?.length > 0) {
          return true
        } else {
          return false
        }
      } catch (error) {
        throw new Error('Error en la petición a users/company/{tenantId}/payment_subscriptions/')
      }
    } catch (error) {
      throw new Error(
        "Error en la petición a 'core/onboarding_steps/status'"
      )
    }
  }
  const totalDiscounts = async (objUser) => {
    try {
      const response = await ErpRepository({
        datasourceUrl: `core/earn_credit/total_credit/`,
        method: 'GET',
      })
      setDiscount({ total_discounts: response.total_credit })
    } catch (error) {
      throw new Error(
        "Error en la petición a 'data/users/discount?email'"
      )
    }
  }
  const clickStandard = () => {
    setPlanSelected(config.packBasic)
    setOpen(true)
    setQuestionPlan('¿Estás seguro que deseas probar el plan Estándar? Al darle click en aceptar, estaremos cerrando tu sesión para poder cargarte el plan por una duración de 15 días.')
  }
  const clickPro = () => {
    setPlanSelected(config.packPro)
    setOpen(true)
    setQuestionPlan('¿Estás seguro que deseas probar el plan Pro? Al darle click en aceptar, estaremos cerrando tu sesión para poder cargarte el plan por una duración de 15 días.')
  }
  const clickSubirPlan = async () => {
    try {
      await ErpRepository({
        dispatch,
        datasourceUrl: 'settings/company/switch_trial_period/',
        method: 'POST',
        data: { pack: planSelected }

      }).then(() => {
        ErpRepository({
          dispatch,
          diferentBaseUrl: true,
          datasourceUrl: 'users/company/',
          method: 'PATCH',
          id: tenant.tenant_id,
          data: { invalidate_cache: true }  
        }).then(()=> {
          setOpen(false)
          setOpenAlert(true)
          setTimeout(() => {
            window.location.assign(`${process.env.REACT_APP_LOBBY_URL}/api/logout`)
          }, 2100)
        })
      })
    } catch (error) {
      setOpen(false)
      setOpenAlertWarning(true)
      throw new Error("Error en la petición a 'core/onboarding_steps/by_company/'")
    }

  }
  const getUrl = (url, text, placeText) => {
    sendAnalytics("Renovar suscripción", {});
    window.open(url, '_blank')
  }
  const childConten = () => {
    return (
      <>
        <div key={0} className="step-accordion__hyperlink-wrapper">
          <img
            className="step-accordion__hyperlink-icon"
            src={logo}
            alt="hyperlink"
          />
          <a
            className="step-accordion__hyperlink"
            href={'https://www.tugerente.com/pricing'}
            target="_blank"
            rel="noopener noreferrer"
          >
            {'Haz click aquí para ver las características de los planes'}
          </a>

        </div>
        <br />
      </>
    )
  }
  const handleClose = () => {
    setOpen(false);
  };
  const handleCloseAlert = () => {
    setOpenAlert(false)
  }
  const handleCloseAlertWarning = () => {
    setOpenAlertWarning(false)
  }
  return (
    <div>
      <h2 className="titule-chards">Suscripción</h2>
      <div className="step-container-new">
        <div>
          <div className="titule-chards pl-3 pr-3 mb-2 pt-3">
            <div className={`GreenAccount GreenAccount--${status}`}></div>
            <h4 className={`SubtiSubMenu2 SubtiSubMenu2--${status}`}>{tenant.name_plan}</h4>
          </div>
          <div >
            <table className="tableItem">
              <tbody>
                {(tenant.pack !== config.packFree || tenant.pack !== config.packUsageBased) && (
                  <tr>
                    <td className="itemLeft">
                      <span>{'El plan vence en:'}</span>
                    </td>
                    <td className="itemRight">
                      <span>{tenant.finish_date}</span>
                    </td>
                  </tr>
                )}

                {(billing.max_sales_amount !== -1.0) && (
                  <tr>
                    <td className="itemLeft">
                      <span>{'Monto vendido al año:'}
                      </span>
                    </td>
                    <td className="itemRight">

                      <span>{formatNumberWithDecimals(sales)} {' de '} {formatNumberWithDecimals(maxSales)} {' '} {titleSales}
                        {(titleSales !== 'Pedidos') && (
                          <Tooltip title={'el tipo de cambio utilizado es de ' + billing.exchange_rate + ' ' + billing.currency_symbol + '.'} placement="right-start" fontSize="small">
                            <IconButton>
                              <InfoIcon fontSize="small" color="primary" />
                            </IconButton>
                          </Tooltip>

                        )}
                      </span>
                    </td>
                  </tr>
                )}
                <tr>
                  <td className="itemLeft">
                    <span>{'Número de usuarios:'}</span>
                  </td>
                  <td className="itemRight">
                    <span>{user.current_users_qty}</span>
                  </td>
                </tr>
                <tr>
                  <td className="itemLeft">
                    <span>{'Descuentos en tu próxima compra:'}</span>
                  </td>
                  <td className="itemRight">
                    <span>{formatNumberWithDecimals(discount.total_discounts)} {' '} {'dólares'}</span>
                  </td>
                </tr>
                <tr>
                  <td className="itemLeft">
                    <a
                      className="step-accordion__hyperlink"
                      href={'https://speckle-earth-959.notion.site/Gana-cr-ditos-para-la-renovaci-n-de-tu-plan-014bd58cf7b546b0917c9105ece490e0'}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {'Descubre como puedes acumular más descuentos'}
                    </a>
                  </td>
                  <td className="itemRight">
                  </td>
                </tr>
              </tbody>
            </table>

            {((renewSubscription === true) || (testPlanStandard === true) || (testPlanPro === true)) && (
              <hr className="line_card_hr" />
            )}
            <div className="titule-chards pl-3 pr-3 mb-2">
              <Stack spacing={2} direction="row">
                {(renewSubscription === true) && (
                  <Button
                    type="button"
                    className="button-renew-subscription"
                    onClick={() =>
                      getUrl(
                        'https://ilove.tugerente.com/Soporteoficial',
                        'Renovar suscripción',
                        'Boton renovar'
                      )
                    }
                  >
                    <span>Renovar Suscripción</span>
                  </Button>

                )}
                {(testPlanStandard === true) && (
                  <Button
                    type="button"
                    className="button-try-standard-plan"
                    onClick={clickStandard}
                  >
                    <span>Probar Plan Estándar</span>
                  </Button>
                )}
                {(testPlanPro === true) && (
                  <Button
                    type="button"
                    className="button-try-pro-plan"
                    onClick={clickPro}
                  >
                    <span>Probar Plan Pro</span>
                  </Button>
                )}

              </Stack>
            </div>
          </div>
        </div>
      </div>
      <div className="step-container-new_2 ">
        <div>
          <div className="titule-chards pl-3 pr-3 mb-2 pt-3">
            <div className={`GreenAccount GreenAccount--normal`}></div>
            <h4 className="SubtiSubMenu2">Perfil</h4>
          </div>
          <div >
            <table className="tableItemProfile">
              <tbody>
                <tr>
                  <td className="itemLeft">
                    <span>{'Nombre:'}</span>
                  </td>
                  <td className="itemRight">
                    <span>{user.nombre}</span>
                  </td>
                </tr>
                <tr>
                  <td className="itemLeft">
                    <span>{'ID del Usuario:'}</span>
                  </td>
                  <td className="itemRight">
                    <span>{user.id}</span>
                  </td>
                </tr>
                <tr>
                  <td className="itemLeft">
                    <span>{'Correo Electrónico:'}</span>
                  </td>
                  <td className="itemRight">
                    <span>{user.email}</span>
                  </td>
                </tr>
                <tr>
                  <td className="itemLeft">
                    <span>{'Telefono:'}</span>
                  </td>
                  <td className="itemRight">
                    <span>{tenant.company_phone}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <br />
      <FeaturesPlan />
      <Popup open={open} handleClose={handleClose} question={questionPlan} text={textPlan} child={childConten()} title={titlePlan} clickAction={clickSubirPlan} />

      <Snackbar open={openAlert} autoHideDuration={2000} onClose={handleCloseAlert} anchorOrigin={{ vertical, horizontal }}>
        <Alert onClose={handleCloseAlert} severity="success" sx={{ width: '100%' }} >
          Se guardo Correctamente!
        </Alert>
      </Snackbar>

      <Snackbar open={openAlertWarning} autoHideDuration={2000} onClose={handleCloseAlertWarning} anchorOrigin={{ vertical, horizontal }}>
        <Alert onClose={handleCloseAlertWarning} severity="warning" sx={{ width: '100%' }} >
          Ya se encuentra con un plan de Prueba!
        </Alert>
      </Snackbar>
    </div>
  )
}

export default Plans;